import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Store } from 'redux';

function loadComponents(): Promise<{[key: string]: React.ComponentClass<any>}> {
  return new Promise((resolve, reject) => {
    require.ensure([
      './components/popup_wrapper/popup_wrapper_container',
    ], () => {
      resolve({
        PopupWrapperContainer: require('./components/popup_wrapper/popup_wrapper_container').default,
      });
    });
  });
}

export default function initPopup<T>(store: Store<T>) {
  (window as any).renderPopupWrapper = (element: Element) => {
    loadComponents()
      .then(({ PopupWrapperContainer }) => {
        render(
          <Provider store={store}>
            <PopupWrapperContainer />
          </Provider>,
          element
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/bundles/popup/index.tsx